import React, { Component } from 'react';
import './ContentContainer.module.scss';
import {lessonsData} from 'utilities/lessons';

import Label from 'components/UI/Label/Label';
import ButtonRight from 'components/UI/ButtonRight/ButtonRight';
import DownloadButtonRight from 'components/UI/download-button/DownloadButtonRight/DownloadButtonRight';


class ContentContainer extends Component {

    constructor() {
        super();

        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.props.closeModal();
    }

    render() {

        var { lessonId } = this.props
        
        const lesson = lessonsData[lessonId];

        let slug = lesson.name.split(" ").join("-").toLowerCase();

        var link = '/images/lessons/thumbnails/' + slug + '.svg';


        return (
            <div styleName='contentcontainer'>
                <div onClick={this.closeModal} styleName='bluepoly'></div>
                <div onClick={this.closeModal} styleName='pinkpoly'></div>
                <div onClick={this.closeModal} styleName='yellowpoly'></div>
                <div styleName='popupimage' style={{backgroundImage: `url(/images/lessons/modal-image/${slug}.jpg`}}>

                </div>
                
                <div styleName='popupcontent'>
                    <div styleName='title-wrapper'>
                        <div styleName='content-tile-left'>
                            <img src={link}></img>
                            <h3>{lesson.name}</h3>
                            <div styleName='labelwrapper'>
                                {<Label text={lesson.label1} extraClass={lesson.label1.toLowerCase()} />}
                                {<Label text={lesson.label2} extraClass={lesson.label2.toLowerCase()} />}
                            </div>
                        </div>
                        <div styleName='title-right'>
                            <p>Level {lesson.level}</p>
                            <p>Duur {lesson.steps.length} stappen</p>
                        </div>
                        </div>
                        <p><b>{lesson.informationbold}</b>
                        <br></br> <br></br>
                        {lesson.information}
                        
                    </p>
                    <ButtonRight text='Start les' link={`/les/${lessonId + 1}`}></ButtonRight>
                    <DownloadButtonRight text='Download Scratch bestand' link={`/storage/lesson/${slug}.zip`}></DownloadButtonRight>
                </div>
            </div>
        );  
    }
}

export default ContentContainer;


// WEBPACK FOOTER //
// ./resources/assets/components/UI/ModalContainer/components/ContentContainer/ContentContainer.jsx